import * as React from 'react';
import unsam_logo from '../assets/img/unsam.png'
import { Link } from 'react-router-dom';
import { keycloakConfig, startKeycloakLogin } from '../keycloak';

const icons = {
    arrowLeft: <path d="M19 12H5m6 7-7-7 7-7" />,
    shield: <path d="M12 3 5 6v5c0 4.2 2.9 8.1 7 10 4.1-1.9 7-5.8 7-10V6l-7-3Z" />,
    key: <path d="M15 7a4 4 0 1 0-2.9 6.8L10 16v2h2v2h2l2.2-2.2A4 4 0 0 0 15 7Z" />,
    login: <path d="M10 17l5-5-5-5M15 12H3m12-8h4a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-4" />,
    check: <path d="m5 12 4 4L19 6" />,
};

function Icon({ name, className = 'h-4 w-4' }) {
    return (
        <svg
            aria-hidden="true"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            {icons[name]}
        </svg>
    );
}

export default function Login() {
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState('');

    const handleKeycloakLogin = async (event) => {
        event.preventDefault();
        setError('');
        setLoading(true);

        try {
            await startKeycloakLogin();
        } catch (err) {
            setError(err?.message || 'Gagal memulai login SSO.');
            setLoading(false);
        }
    };
    return (
        <main className="relative min-h-screen overflow-hidden bg-brand-soft px-4 py-8 text-brand-navy sm:px-6">
            <div className="absolute inset-x-0 top-0 h-72 bg-brand-navy" />
            <div className="absolute -right-24 top-16 h-72 w-72 rounded-full bg-brand-blue/30 blur-3xl" />
            <div className="absolute -left-20 bottom-10 h-72 w-72 rounded-full bg-brand-green/20 blur-3xl" />

            <Link to="/" className="relative z-10 inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-4 py-2 text-sm font-bold text-white no-underline backdrop-blur transition hover:bg-white hover:text-brand-navy sm:absolute sm:left-8 sm:top-8">
                <Icon name="arrowLeft" />
                Kembali
            </Link>

            <div className="relative z-10 mx-auto flex min-h-[calc(100vh-4rem)] w-full max-w-5xl items-center">
                <div className="grid w-full overflow-hidden rounded-lg border border-white/60 bg-white shadow-2xl shadow-slate-900/15 lg:grid-cols-[1fr_0.95fr]">
                    <section className="relative overflow-hidden bg-brand-navy px-7 py-8 text-white sm:px-10 sm:py-12">
                        <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-brand-gold via-brand-green to-brand-blue" />
                        <div className="pointer-events-none absolute -right-20 -top-20 h-64 w-64 rounded-full bg-brand-blue/35 blur-3xl" />
                        <div className="relative">
                            <div className="flex items-center gap-3">
                                <span className="inline-flex h-12 w-12 items-center justify-center rounded-lg bg-white p-2 shadow-lg shadow-black/20">
                                    <img src={unsam_logo} className="h-full w-full object-contain" alt="Logo Universitas Samudra" />
                                </span>
                                <span>
                                    <span className="block font-display text-base font-extrabold">RPU Unsam</span>
                                    <span className="block text-xs font-semibold text-white/65">Repository Publikasi Universitas Samudra</span>
                                </span>
                            </div>

                            <div className="mt-16 max-w-md pb-8 md:mt-20">
                                <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-3 py-1 text-xs font-extrabold uppercase text-brand-gold">
                                    <Icon name="shield" className="h-3.5 w-3.5" />
                                    SSO Secure Access
                                </span>
                                <h1 className="mt-5 font-display text-3xl font-extrabold leading-tight sm:text-4xl">
                                    Masuk dengan akun resmi Universitas Samudra
                                </h1>
                                <p className="mt-4 text-sm leading-7 text-slate-300 sm:text-base">
                                    Gunakan autentikasi Keycloak untuk mengakses dashboard publikasi, profil, dan pengelolaan data riset.
                                </p>
                            </div>

                           
                        </div>
                    </section>

                    <section className="px-7 py-8 sm:px-10 sm:py-12">
                        <form noValidate onSubmit={handleKeycloakLogin} className="flex h-full min-h-80 flex-col justify-center">
                            <div className="mb-8">
                                <span className="inline-flex h-12 w-12 items-center justify-center rounded-lg bg-brand-soft text-brand-blue">
                                    <Icon name="login" className="h-6 w-6" />
                                </span>
                                <h2 className="mt-5 font-display text-2xl font-extrabold">Login SSO</h2>
                                <p className="mt-2 text-sm leading-6 text-slate-600">
                                    Anda akan diarahkan ke halaman Keycloak untuk verifikasi akun.
                                </p>
                            </div>

                            {!keycloakConfig.hasKeycloakConfig && (
                                <div className="mb-4 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm font-semibold text-red-700">
                                    Konfigurasi SSO belum lengkap. Hubungi admin aplikasi.
                                </div>
                            )}

                            {error && (
                                <div className="mb-4 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm font-semibold text-red-700">
                                    {error}
                                </div>
                            )}

                            <button
                                disabled={loading || !keycloakConfig.hasKeycloakConfig}
                                type="submit"
                                className="inline-flex h-12 w-full items-center justify-center gap-3 rounded-lg bg-brand-blue px-4 text-sm font-extrabold text-white shadow-lg shadow-blue-900/15 transition hover:bg-brand-navy focus:outline-none focus:ring-2 focus:ring-brand-blue focus:ring-offset-2 disabled:cursor-not-allowed disabled:bg-slate-400 disabled:shadow-none"
                            >
                                {loading ? <span className="h-5 w-5 animate-spin rounded-full border-2 border-white/40 border-t-white" /> : <Icon name="shield" />}
                                Login dengan SSO
                            </button>

                            <p className="mt-5 text-center text-xs leading-5 text-slate-500">
                                Pastikan popup atau redirect browser tidak diblokir ketika proses login dimulai.
                            </p>
                        </form>
                    </section>
                </div>
            </div>
        </main>
    );
}
